// 拦截器
import Vue from 'vue'
import axios from "axios";
const service = axios.create({
    baseURL: '',
	headers:{}
    // timeout: 30000 // request timeout
});
// request interceptor
service.interceptors.request.use(
    res => {
        if (res) {
			let langInfo = sessionStorage.getItem('activeLanguage')
			let language_id = 1
			if(langInfo){
				language_id = JSON.parse(langInfo).id
			}
			// console.log('language_id' in res.params);
			// console.log(res.params.hasOwnProperty('language_id'));
			if(res.method === 'get'){
				if(res.params && !res.params.hasOwnProperty('language_id')){
					res.params.language_id = language_id
				}
				if(!res.params){
					res.params = {}
					res.params.language_id = language_id
				}
			}
            return res;
        }
    },
    err => {
        return Promise.reject(err);
    }
);

// response interceptor
service.interceptors.response.use(
    res => {
		return res.data;
        if (res&&res.data.code==200) {
            return res.data;
        }else{
            Vue.prototype.$message({
                message: res.data.message,
                type: 'warning'
            });
        }
    },
    err => {
        return Promise.reject(err);
    }
);

export {
    service as request
};
